export enum CertificateDocumentType {
  Certificate = 0,
  TestReport = 1,
  Others = 2,
  R2CPackage = 3,
  InspectionSurveillance = 4,
}

export enum CertificateDocumentTypeV2 {
  None = -1,
  Certificate = 0,
  TestReport = 1,
  R2CPackage = 3,
  InspectionSurveillance = 4,
  InternalFiles = 2,
}

export enum ECMContentType {
  None = 0,
  Certificate = 1,
  TestReport = 2,
  R2CPackageDocument = 3,
  FactoryInspectionReports = 4,
  MarketSurveillanceReports = 5,
  InternalFiles = 6,
  Doc = 7,
  ClassificationReport = 8,
  AssessmentReport = 9,
  DescriptiveReport = 10,
  EvaluationReport = 11,
  ConformityMarking = 12,
  WithdrawalLetter = 13,
  SuspensionLetter = 14,
  LetterReport = 15,
  Eta = 16,
  Ukta = 17,
}
